module.exports = __webpack_public_path__ + "img/purple.7317ecac.png";